import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import DealContext from '../DealContext';
import FileNotFound from '../../FileNotFound';
import DealQuotesPie from './DealQuotesPie';

const ChartCard = () => {
  const { quoteList, handleNewQuote } = useContext(DealContext);

  const hasQuotes = quoteList.length > 0;

  return (
    <Card>
      <Card.Body>
        <Card.Title>
          <strong>{quoteList.length}</strong> {`Quote${quoteList.length !== 1 ? 's' : ''}`}
        </Card.Title>
        {hasQuotes === true ? (
          <DealQuotesPie quotes={quoteList} />
        ) : (
          <FileNotFound className="p-4">
            There aren't any quotes under this deal yet. Use the{' '}
            <span style={{ color: 'var(--green-9)' }}>
              <i className="fas fa-plus fa-border" style={{ backgroundColor: 'var(--green-2)' }} />
            </span>{' '}
            to add one or just{' '}
            <a
              href=""
              onClick={e => {
                e.preventDefault();
                handleNewQuote();
              }}
            >
              click here
            </a>
            .
          </FileNotFound>
        )}
      </Card.Body>
    </Card>
  );
};

export default ChartCard;
